import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Choices } from '../../types/choice';

type ChangeCallbackFn = (event: unknown) => void;

@Component({
    selector: 'pace-forms-choices',
    templateUrl: './choices.component.html',
    styleUrls: ['./choices.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ChoicesComponent),
            multi: true,
        },
    ],
})
export class ChoicesComponent implements ControlValueAccessor {
    @Input()
    public choices: Choices;

    public selectedValue: string | undefined;
    public disabled: boolean;

    public onChanged: ChangeCallbackFn = () => undefined;
    public onTouched: VoidFunction = () => undefined;
    public constructor(private readonly cdr: ChangeDetectorRef) {}

    public reset(): void {
        this.selectedValue = undefined;
        this.onChanged(this.selectedValue);
    }

    public registerOnChange(fn: VoidFunction): void {
        this.onChanged = fn;
    }

    public registerOnTouched(fn: VoidFunction): void {
        this.onTouched = fn;
    }

    public writeValue(val: string): void {
        this.selectedValue = val;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
        this.cdr.detectChanges();
    }
}
